module.exports = __webpack_public_path__ + "img/google.70fec879.png";